import { PartialTheme } from '@nivo/theming'

import dataPalettes from '../../../tokens/dataPalettes.json'

export type Colors = 'blue' | 'red' | 'green' | 'yellow' | 'orange' | 'teal' | 'magenta' | 'coral' | 'indigo' | 'maroon' | 'purple' | 'navy' | 'gray'

export const QualitativeColorOptions: Record<Colors, string> = {
    blue: dataPalettes['mode-1']['chart-qualitative-01-primary'],
    purple: dataPalettes['mode-1']['chart-qualitative-02-primary'],
    teal: dataPalettes['mode-1']['chart-qualitative-03-primary'],
    red: dataPalettes['mode-1']['chart-qualitative-04-primary'],
    coral: dataPalettes['mode-1']['chart-qualitative-05-primary'],
    maroon: dataPalettes['mode-1']['chart-qualitative-06-primary'],
    green: dataPalettes['mode-1']['chart-qualitative-07-primary'],
    indigo: dataPalettes['mode-1']['chart-qualitative-08-primary'],
    magenta: dataPalettes['mode-1']['chart-qualitative-09-primary'],
    yellow: dataPalettes['mode-1']['chart-qualitative-10-primary'],
    navy: dataPalettes['mode-1']['chart-qualitative-11-primary'],
    orange: dataPalettes['mode-1']['chart-qualitative-12-primary'],
    gray: dataPalettes['mode-1']['chart-qualitative-13-primary'],
}

export const QualitativeColorOptionsSecondary: Record<Colors, string> = {
    blue: dataPalettes['mode-1']['chart-qualitative-01-secondary'],
    purple: dataPalettes['mode-1']['chart-qualitative-02-secondary'],
    teal: dataPalettes['mode-1']['chart-qualitative-03-secondary'],
    red: dataPalettes['mode-1']['chart-qualitative-04-secondary'],
    coral: dataPalettes['mode-1']['chart-qualitative-05-secondary'],
    maroon: dataPalettes['mode-1']['chart-qualitative-06-secondary'],
    green: dataPalettes['mode-1']['chart-qualitative-07-secondary'],
    indigo: dataPalettes['mode-1']['chart-qualitative-08-secondary'],
    magenta: dataPalettes['mode-1']['chart-qualitative-09-secondary'],
    yellow: dataPalettes['mode-1']['chart-qualitative-10-secondary'],
    navy: dataPalettes['mode-1']['chart-qualitative-11-secondary'],
    orange: dataPalettes['mode-1']['chart-qualitative-12-secondary'],
    gray: dataPalettes['mode-1']['chart-qualitative-13-secondary'],
}

export const QualitativeColorOptionsStrong: Record<Colors, string> = {
    blue: dataPalettes['mode-1']['chart-qualitative-01-strong'],
    purple: dataPalettes['mode-1']['chart-qualitative-02-strong'],
    teal: dataPalettes['mode-1']['chart-qualitative-03-strong'],
    red: dataPalettes['mode-1']['chart-qualitative-04-strong'],
    coral: dataPalettes['mode-1']['chart-qualitative-05-strong'],
    maroon: dataPalettes['mode-1']['chart-qualitative-06-strong'],
    green: dataPalettes['mode-1']['chart-qualitative-07-strong'],
    indigo: dataPalettes['mode-1']['chart-qualitative-08-strong'],
    magenta: dataPalettes['mode-1']['chart-qualitative-09-strong'],
    yellow: dataPalettes['mode-1']['chart-qualitative-10-strong'],
    navy: dataPalettes['mode-1']['chart-qualitative-11-strong'],
    orange: dataPalettes['mode-1']['chart-qualitative-12-strong'],
    gray: dataPalettes['mode-1']['chart-qualitative-13-strong'],
}

export const DivergentColorOptions = {
    low: dataPalettes['mode-1']['chart-divergent-low'],
    lowmid: dataPalettes['mode-1']['chart-divergent-lowmid'],
    mid: dataPalettes['mode-1']['chart-divergent-mid'],
    midhigh: dataPalettes['mode-1']['chart-divergent-midhigh'],
    high: dataPalettes['mode-1']['chart-divergent-high'],
    warning: dataPalettes['mode-1']['chart-divergent-warning'],
    critical: dataPalettes['mode-1']['chart-divergent-critical'],
}

export const baseTheme: PartialTheme = {
    background: '#fff',
    axis: {
        ticks: {
            line: {
                strokeWidth: 0,
            },
            text: {
                fontFamily: 'Inter, monospace',
            },
        },
    },
    text: {
        fontFamily: 'Inter, monospace',
    },
    labels: {
        text: {
            outlineColor: '#f5f5f5',
            outlineWidth: 2,
        },
    },
}
